import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
const MIN_YEAR = 2021;
const MAX_YEAR = dayjs().year();
export default function WeekMonthFilter({ value, onChange }) {
    var _a;
    const emit = next => {
        onChange(next);
    };
    const handleModeChange = mode => {
        var _a;
        if (mode === 'year') {
            // 年モードは年だけ。月は保持しない（過去に選んだ月が代表表示に乗らないようにする）
            emit({
                mode: 'year',
                year: value.year
            });
        }
        if (mode === 'month') {
            emit({
                mode: 'month',
                year: value.year,
                month: (_a = value.month) !== null && _a !== void 0 ? _a : dayjs().month() + 1
            });
        }
    };
    const handleYearChange = d => {
        if (!d)
            return;
        emit({
            mode: 'year',
            year: d.year()
        });
    };
    const handleMonthChange = d => {
        if (!d)
            return;
        emit({
            mode: 'month',
            year: d.year(),
            month: d.month() + 1
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-4 w-fit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: () => handleModeChange('year'),
        className: value.mode === 'year' ? '!bg-[#f0c52a36]' : ''
    }, "\u5E74"), /*#__PURE__*/ React.createElement(Button, {
        onClick: () => handleModeChange('month'),
        className: value.mode === 'month' ? '!bg-[#f0c52a36]' : ''
    }, "\u6708")), value.mode === 'year' && /*#__PURE__*/ React.createElement(DatePicker, {
        picker: "year",
        value: dayjs(`${value.year}-01-01`),
        allowClear: false,
        disabledDate: c => {
            if (!c)
                return false;
            const y = c.year();
            return y < MIN_YEAR || y > MAX_YEAR;
        },
        onChange: handleYearChange
    }), value.mode === 'month' && /*#__PURE__*/ React.createElement(DatePicker, {
        picker: "month",
        value: dayjs(`${value.year}-${((_a = value.month) !== null && _a !== void 0 ? _a : dayjs().month() + 1).toString().padStart(2, '0')}-01`),
        format: "YYYY-MM",
        allowClear: false,
        disabledDate: c => c && c > dayjs().endOf('month'),
        onChange: handleMonthChange
    }));
}
